import { EnterprisePortalLayout } from 'shared/ui/portal-layout';
import { LicenseAgreements } from './LicenseAgreements';

export const LicenseAgreementsPage = () => {
    return (
        <EnterprisePortalLayout>
            <LicenseAgreements />
        </EnterprisePortalLayout>
    );
};
